import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { AddParamsService, Params } from '../utilis/add-params-service';
import { CarActivity } from '../../models/car-activity';
import { GenericPaginated } from '../../models/generic-paginated';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CarActivityService {

  private baseUrl = environment.url;

  private http = inject(HttpClient)
  private addParamsService = inject(AddParamsService)

  getCarActivityList = (carID: string, params?: Params): Observable<GenericPaginated<CarActivity>> => {
    return this.http.get<GenericPaginated<CarActivity>>(`${this.baseUrl}/cars/${carID}/activities`, {
      params: this.addParamsService.addParams(params)
    });
  }
}
